module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "version1.0.3"
  }, [_c('ajax-intercept', {
    on: {
      "start": _vm.start,
      "finish": _vm.finish
    }
  }), _vm._v(" "), _c('barra-navegacao', {
    attrs: {
      "autenticado": _vm.auth,
      "rotas": _vm.routes,
      "usuario": _vm.usuarioLogado.primeiroNome,
      "sshd": _vm.usuarioLogado.sshd
    }
  }), _vm._v(" "), _c('barra-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auth),
      expression: "auth"
    }],
    staticClass: "hidden-xs hidden-sm",
    attrs: {
      "rotas": _vm.routes,
      "declaracaoVisitada": _vm.declaraVisited,
      "avaliacaoVisitada": _vm.avaliaVisited,
      "recadastramentoVisitada": _vm.recadastraVisited,
      "formulariosVisitada": _vm.formulariosVisited,
      "feriasVisitada": _vm.feriasVisited,
      "valeAlimentacaoVisitada": _vm.valeAlimentacaoVisited
    }
  }), _vm._v(" "), _c('barra-evolucao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stepVisible),
      expression: "stepVisible"
    }],
    attrs: {
      "stepOne": _vm.number,
      "stepTwo": _vm.number,
      "stepThree": _vm.number,
      "stepFour": _vm.number,
      "stepFive": _vm.number,
      "stepSix": _vm.number,
      "stepSeven": _vm.number,
      "textOne": _vm.number,
      "textTwo": _vm.number,
      "textThree": _vm.number,
      "textFour": _vm.number,
      "textFive": _vm.number,
      "textSix": _vm.number,
      "textSeven": _vm.number,
      "contentNumber": _vm.number,
      "contentName": _vm.stepName
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('rodape', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auth),
      expression: "auth"
    }],
    attrs: {
      "id": "footer"
    }
  }), _vm._v(" "), _c('botao-ir-para-topo'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.carregando) ? _c('loader') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e551d8c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Site.vue
// module id = ysmu
// module chunks = 5